import {
  ConsentAgreementTypeEnum,
  ConsentNameEnumType,
  useCurrentConsentAgreementTextQuery,
  useSaveConsentMutation,
} from '../../../../../gql/generated/graphql';

const useMarketplaceListingConsent = (dealId: string) => {
  const { data, loading } = useCurrentConsentAgreementTextQuery({
    variables: { agreementType: ConsentAgreementTypeEnum.MarketplaceListing },
  });

  const [saveConsentMutation] = useSaveConsentMutation();

  const saveConsent = async () => {
    await saveConsentMutation({
      variables: { type: ConsentNameEnumType.MarketplaceListing, dealId },
    });
  };

  const consentText = data?.currentConsentAgreementText?.text ?? '';

  return {
    consentText,
    consentLoading: loading && !consentText,
    saveConsent,
  };
};

export default useMarketplaceListingConsent;
